import React, { useState, useEffect, useCallback } from 'react'

import { GoogleMapControls, GoogleMap, GoogleMapLegend, GoogleMapBoundary, MapController, MiniMap, Notification } from '../../components'

import ModalAssetBranch from '../../components/MapAssetLoader/ModalAssetBranch'

import useAssetMap from '../../components/MapAssetLoader'
import OnMarkerClick from '../../components/MapAssetLoader/MarkerClick'
import CustomModal from '../../components/CustomModal'

import { ReactComponent as RefreshIcon } from '../../assets/icons/map/IconSwitch.svg'
import { services } from '../../services'
import {useHistory } from 'react-router-dom'

const DEFAULT_ZOOM_LEVEL = 7
const DEFAULT_CENTER_LEVEL = { lat: 43.043619, lng: -76.145119 }
const ZOOM_LEVEL_FOR_ASSET_LOAD = 18

export const SearchingNotification = ({ location, submitting }) => {
  return submitting && (
    <Notification Icon={RefreshIcon} className="notification-info notification-map">
      Searching for {location || 'address'}
    </Notification>
  )
}

export const NothingFoundNotification = () => {
  return (
    <Notification className="notification-warning notification-map">
      Unable to find this address within the service area.
      Please refine your search criteria
    </Notification>
  )
}

export const LoadingAssetsNotification = () => {
  return (
    <Notification Icon={RefreshIcon} className="notification-info notification-map">
      Loading Assets
    </Notification>
  )
}

export const LoadedAssetNotification = () => {
  return (
    <Notification className="notification-info notification-map notification-loaded-asset">
      Loading of Assets at this location has been completed. Click on the icons to see their information.
    </Notification>
  )
}

export const ErrorAsset = () => {
  return(
    <Notification className="notification-warning notification-map">
      Something went wrong. Please try again
    </Notification> 
  )
}

const GoogleMapContainer = () => {
  const [location, setLocation] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const history = useHistory()
  const [mapAPI, setMapAPI] = useState()
  const [geocoderAPI, setGeocoderAPI] = useState()
  const [, setAutocompleteAPI] = useState()
  const [, setPolygon1] = useState()
  const [, setPolygon2] = useState()
  const [, setPolygon3] = useState()

  const [zoomLevel] = useState(DEFAULT_ZOOM_LEVEL)
  const [centerLevel] = useState(DEFAULT_CENTER_LEVEL)
  const [loadingAssets, setLoadingAssets] = useState(false)
  const [loadedAssetMessage, setLoadedAssetMessage] = useState(false)
  const [nothingFoundMessage, setNothingFoundMessage] = useState(false)
  const [assetError, setAssetError] = useState(false)

  const [assets, setAssets] = useState([])

  const [nestModal, setNestModal] = useState(false)
  const [markerStatus, setMarkerStatus] = useState(false)
  const [, setMarkerColor] = useState('gray')
  const [asset, setAsset] = useState()
  const [closeIconStatus, setCloseIconStatus] = useState(false)
  const [isErrorModalStyle, setIsErrorModalStyle] = useState(false)
 
  const { api } = services

  const mapOptions = {
    zoom: zoomLevel,
    center: centerLevel,
    disableDefaultUI: true,
    tilt: 0,
    scrollwheel: false,
    gestureHandling: "greedy",
    styles: [
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
    ],
  }

  const fetchOutageAssets = useCallback((lat,lng) => {
    setSubmitting(false)
    let timer
    setLoadingAssets(true) 
    api.getRadiusAsset(lat,lng).then((response) => {
      setAssets([])
      if(response.data.TotalAssestsCount !== 0){
        setLoadingAssets(false)
        setLoadedAssetMessage(true)
        if(assets === []){
          setLoadingAssets(true)
        }
        setAssets(response.data.TotalAssetDetails) 
        setLoadingAssets(false)
        timer = setTimeout(() => {
          setLoadedAssetMessage(false)
        }, 3000)
      }
      else if(response.data.TotalAssestsCount === 0){
        setLoadingAssets(false)
        showNotFoundMessage(true)
        setAssets([])
      }
    }, (error) => {
      setLoadingAssets(false)
      showAssetErrorMessage(true)
    })
 
    return () => {
      window.clearTimeout(timer)
    }
    // eslint-disable-next-line
  },[api])

  const onLocationSubmit = ({ location }) => {
    if (location && location.length >= 1) {
      setSubmitting(true)
      geocoderAPI && geocoderAPI.geocode({ 'address': location,
      }, function (results, status) {
        if(status === window.google.maps.GeocoderStatus.OK ){
          if(results && results[0].geometry !== undefined){
            mapAPI && mapAPI.setCenter(results[0].geometry.location)
            if (mapAPI.getZoom() !== 18) {
              mapAPI.setZoom(18)
            }
            else{
              fetchZipcode()
            }
          }
          else{
            setSubmitting(false)
            showNotFoundMessage(true)
          }
        }
        else{
          setSubmitting(false)
          showNotFoundMessage(true)
        }
      })
    }
  }
  const onLocationChange = async ({ location }) => {
    setLocation(location)
    await sleep(1000)
    setSubmitting(false)
  }

  const showNotFoundMessage = async () => {
    setNothingFoundMessage(true)
    await sleep(5000)
    setNothingFoundMessage(false)
  }
  const showAssetErrorMessage =  async () => {
    setAssetError(true)
    await sleep(5000)
    setAssetError(false)
  }

  const onGoogleMapMount = (mapAPI, autocompleteAPI, geocoderAPI, mountProps) => {
    setMapAPI(mapAPI)
    setAutocompleteAPI(autocompleteAPI)
    setGeocoderAPI(geocoderAPI)
  }

  //modal toggle
  const modalToggle = () => {
    setNestModal(false)
    setMarkerStatus(false)
  }
  //hiding close icon modal for confirm modal 
  const noCloseIcon = (closeIconButton) => {
    setCloseIconStatus(closeIconButton)
  }

  const sleep = async (ms) => {
    return new Promise((resolve, reject) => {
      if (isNaN(ms)) {
        reject(new Error('sleep requires a valid number'))
      } else {
        window.setTimeout(resolve, ms)
      }
    })
  }
  const fetchZipcode = ()=>{
    setSubmitting(false)
    geocoderAPI && geocoderAPI.geocode({ 'latLng': mapAPI.getCenter()}, function (results, status) {
      if (status === window.google.maps.GeocoderStatus.OK) {
        if(results[0].geometry && results[0].geometry.location !== undefined){
          fetchOutageAssets(results[0].geometry.location.lat(), results[0].geometry.location.lng())
        }
        else {
          showNotFoundMessage(true)
        }
      }
      else {
        showNotFoundMessage(true)
      }
    })
  }

  useEffect(() => {

    let timer3000
    let timer1000

    mapAPI && mapAPI.addListener("dragend", function () {
      if(mapAPI.getZoom() >= 18){
        geocoderAPI && geocoderAPI.geocode({ 'latLng': mapAPI.getCenter() }, function (results, status) {
          if (status === window.google.maps.GeocoderStatus.OK) {
            if(results[0].geometry && results[0].geometry.location !== undefined){
              fetchOutageAssets(results[0].geometry.location.lat(), results[0].geometry.location.lng())
            }
            else {
              showNotFoundMessage(true)
            }
          }
          else {
            showNotFoundMessage(true)
          }

        })
      }
    })

    const onZoomChange = async () => {
      const zoom = mapAPI.getZoom()
      timer1000 = sleep(1000)
      await timer1000
      if (zoom < ZOOM_LEVEL_FOR_ASSET_LOAD) {
        setAssets([])
        loadedAssetMessage && setLoadedAssetMessage(false)
      }
      else if(zoom === ZOOM_LEVEL_FOR_ASSET_LOAD){
        fetchZipcode()
      }
      return ()=>{
        if(mapAPI && (!mapAPI.getZoom() >= 18)){
          setAssets([])
        }
      }
    }

    mapAPI && mapAPI.addListener('zoom_changed', onZoomChange)

    return () => {
      window.clearTimeout(timer1000, timer3000)
      if(mapAPI && (!mapAPI.getZoom() >= 18)){
        setAssets([])
      }
      mapAPI && mapAPI.removeListener && mapAPI.removeListener('zoom_changed', onZoomChange)
    }
    // eslint-disable-next-line
  }, [mapAPI,geocoderAPI])

  useAssetMap(mapAPI, assets, setAsset, OnMarkerClick, nestModal, setNestModal, markerStatus, setMarkerStatus, setMarkerColor, history)

  return (
    <>
      <div className="outage-map">
        <GoogleMapControls {...{ location, onLocationSubmit, onLocationChange }}>
          <GoogleMapLegend />
        </GoogleMapControls>
        <GoogleMap onMount={onGoogleMapMount} options={mapOptions} />
        <SearchingNotification {...{ location, submitting }} />
        {mapAPI && <GoogleMapBoundary
          map={mapAPI} nestModal={nestModal}
          setAsset={setAsset} setNestModal={setNestModal}
          setPolygon1={setPolygon1} setPolygon2={setPolygon2} setPolygon3={setPolygon3}
        />}
        {mapAPI && <MapController map={mapAPI} />}
        {mapAPI && <MiniMap map={mapAPI} />}
        {loadingAssets && <LoadingAssetsNotification />}
        {!loadingAssets && loadedAssetMessage && <LoadedAssetNotification />}
        {!submitting && nothingFoundMessage && <NothingFoundNotification />}
        {!submitting && assetError && <ErrorAsset/>}

        {
          nestModal
            ? <CustomModal
              modalContent={
                <ModalAssetBranch
                  asset={asset}
                  setNestModal={setNestModal}
                  onclickOpen={modalToggle}
                  noCloseIcon={noCloseIcon}
                  isErrorModalStyle={isErrorModalStyle}
                  setIsErrorModalStyle={setIsErrorModalStyle}
                />
              }
              onclickOpen={modalToggle}
              isShowContent={true}
              hideCloseIcon={closeIconStatus}
              noCloseIcon={noCloseIcon}
              isErrorModalStyle={isErrorModalStyle}
              setIsErrorModalStyle={setIsErrorModalStyle}
            />
            : null
        }
      </div>
    </>
  )
}

export default GoogleMapContainer
